"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaucetsApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class FaucetsApi extends runtime.BaseAPI {
    /**
     * Get BTC tokens for the testnet
     * Get BTC tokens
     */
    async runFaucetBtcRaw(requestParameters, initOverrides) {
        if (requestParameters.address === null || requestParameters.address === undefined) {
            throw new runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling runFaucetBtc.');
        }
        const queryParameters = {};
        if (requestParameters.address !== undefined) {
            queryParameters['address'] = requestParameters.address;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/faucets/btc`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.RunFaucetResponseFromJSON(jsonValue));
    }
    /**
     * Get BTC tokens for the testnet
     * Get BTC tokens
     */
    async runFaucetBtc(requestParameters, initOverrides) {
        const response = await this.runFaucetBtcRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get STX tokens for the testnet
     * Get STX tokens
     */
    async runFaucetStxRaw(requestParameters, initOverrides) {
        if (requestParameters.address === null || requestParameters.address === undefined) {
            throw new runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling runFaucetStx.');
        }
        const queryParameters = {};
        if (requestParameters.address !== undefined) {
            queryParameters['address'] = requestParameters.address;
        }
        if (requestParameters.stacking !== undefined) {
            queryParameters['stacking'] = requestParameters.stacking;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/faucets/stx`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.RunFaucetResponseFromJSON(jsonValue));
    }
    /**
     * Get STX tokens for the testnet
     * Get STX tokens
     */
    async runFaucetStx(requestParameters, initOverrides) {
        const response = await this.runFaucetStxRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.FaucetsApi = FaucetsApi;
//# sourceMappingURL=FaucetsApi.js.map